<template>
    <common-modal v-if="isOpen" width="photo-upload" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="small">
            <div class="profile-photo-upload__modal">
                <div class="profile-photo-upload__modal-left">
                    <div class="profile-photo-upload__modal-button" @click="$refs.fileInput.click()">
                        <div>
                            <common-icon name="camera-blue" size="gigantic"></common-icon>
                            <div>
                                {{ $t('modals.profile_photo_upload_modal.upload_new') }}
                            </div>
                        </div>
                    </div>
                    <input
                        ref="fileInput"
                        type="file"
                        style="display: none"
                        accept="image/png,image/jpg,image/jpeg"
                        @change="selectImage"
                    />
                </div>

                <div class="croppie-container">
                    <vue-croppie
                        ref="croppieRef"
                        :key="croppieComponentKey"
                        customClass="croppie"
                        :boundary="boundary"
                        :viewport="viewport"
                        :enableResize="false"
                        :showZoomer="false"
                        @update="croppieUpdate"
                    ></vue-croppie>

                    <common-icon
                        v-if="showUserIcon"
                        class="croppie__icon croppie__absolute-center"
                        name="user-profile-gray"
                        size="mega"
                    ></common-icon>

                    <img v-if="photoAvatar" class="croppie__absolute-center" :src="previewPhoto" height="425" width="425" />

                    <div v-if="showTrashIcon" class="croppie__trash-icon" @click="removeImage()">
                        <common-icon name="trash-white" size="large"></common-icon>
                    </div>
                </div>
            </div>

            <common-content-wrapper width="small-medium">
                <common-slider
                    class="photo-upload-slider"
                    :min="minZoom"
                    :max="150"
                    :step="1"
                    :value="sliderValue"
                    :isDisabled="!isImageSelected"
                    icon="user-profile-gray"
                    @change="zoomChange($event)"
                ></common-slider>
            </common-content-wrapper>

            <common-buttons>
                <common-button
                    :isProcessing="isProcessing"
                    :isDisabled="isSubmitDisabled"
                    :label="$t('common.microcopy.save')"
                    type="primary"
                    @click="saveChanges"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            isOpen: { type: Boolean, required: true },
            previewPhoto: { type: String, default: '' },
        },

        data() {
            return {
                sliderValue: 35,
                minZoom: 36,
                lastZoom: null,
                isImageSelected: false,
                isImageRemoved: false,
                isProcessing: false,
                croppieComponentKey: 0,
            }
        },

        computed: {
            showUserIcon() {
                return !this.isImageSelected && !this.photoAvatar
            },

            showTrashIcon() {
                return this.isImageSelected || !!this.photoAvatar
            },

            photoAvatar() {
                if (!this.previewPhoto || this.isImageRemoved) {
                    return null
                }

                return this.previewPhoto
            },

            isSubmitDisabled() {
                return !this.isImageSelected && !this.isImageRemoved
            },

            boundary() {
                if (this.isMobileLarge) {
                    return { width: this.windowWidth * 0.8, height: this.windowWidth * 0.8 }
                }
                return { width: 570, height: 430 }
            },
            viewport() {
                if (this.isMobileLarge) {
                    return { width: this.windowWidth * 0.8, height: this.windowWidth * 0.8, type: 'circle' }
                }
                return { width: 300, height: 300, type: 'circle' }
            },
        },

        methods: {
            selectImage(e) {
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) return

                var reader = new FileReader()
                reader.onload = (e) => {
                    this.$refs.croppieRef
                        .bind({
                            url: e.target.result,
                        })
                        .then(() => {
                            this.isImageSelected = true
                            this.startZoom = null
                            const min = document.getElementsByClassName('cr-slider')[0].getAttribute('min')
                            this.minZoom = Math.ceil(min * 100)
                            this.croppieUpdate({ zoom: this.lastZoom })
                        })
                }

                reader.readAsDataURL(files[0])
            },

            removeImage() {
                this.clearData()
                if (this.previewPhoto) {
                    this.isImageRemoved = true
                }
                this.croppieComponentKey = this.croppieComponentKey + 1
            },

            crop() {
                let options = {
                    type: 'base64',
                    size: { width: 400, height: 400 },
                    format: 'png',
                }
                this.$refs.croppieRef.result(options, (output) => {
                    this.uploadAvatar(output)
                })
            },

            saveChanges() {
                this.isProcessing = true
                if (this.isImageSelected) {
                    this.crop()
                } else if (this.isImageRemoved) {
                    this.removeAvatar()
                }
            },

            uploadAvatar(file) {
                this.$emit('save-photo', file)
            },

            removeAvatar() {
                this.$emit('remove-photo')
            },

            resetModal(clearData) {
                if (clearData) {
                    this.clearData()
                }
                this.emitEvent({ name: 'close' })
                this.isProcessing = false
            },

            zoomChange({ value }) {
                this.$refs.croppieRef.setZoom(value / 100)
            },

            croppieUpdate({ zoom }) {
                this.lastZoom = zoom
                if (!this.startZoom) {
                    this.startZoom = zoom
                    this.sliderValue = zoom * 100
                }
            },

            clearData() {
                this.isImageSelected = false
                this.sliderValue = 35
                this.minZoom = 36
                this.lastZoom = null
                this.isImageRemoved = false
            },
        },

        watch: {
            isOpen() {
                if (!this.isOpen) {
                    this.clearData()
                }
            },
        },
    }
</script>
